import React from 'react';

import Choice from './Choice';
import HomeButton  from './HomeButton';
import WalletOverview from './WalletOverview';
import AddSpaces from './AddSpaces';

import WarImg from '../assets/warCard.svg';
import ThreeImg from '../assets/threeCard.svg';
import FiveImg from '../assets/fiveCard.svg';

import '../css/Home.scss';

export default function Home() {
    const warDesc = "1 card against 1 card. Doesn’t get any simpler than that!";
    const threeCardDesc = "3 card vs 3 card. Up the ante as you go.";
    const fiveCardDesc = "5 card vs 5 card. Up the ante as you go.";

    return (
        <div className='home flex-container column-flex'>
            <div className='home-header flex-container space-between'>
                <HomeButton type='poker-home' content='Poker Room Home' />
                <WalletOverview />
                <AddSpaces />
            </div>
            <div className='choices-container flex-container space-between'>
                <Choice title="War" description={warDesc} image={WarImg} />
                <Choice title="3 Card" description={threeCardDesc} image={ThreeImg} />
                <Choice title="5 Card" description={fiveCardDesc} image={FiveImg} />
            </div>
        </div>
    )
}